import {
  FILTER_OPERATOR_ENUMS,
  FILTER_RULE_ENUMS,
  GURU_LEASING_MAIL_EXTENSION,
} from '@constants';

import { BOOKINGS_STAGES_ORDER } from 'components/bookings/constants';

export const getPayload = (values) => {
  const prepaidMonths = values?.prepaidMonths
    ?.map((month) => month.value)
    ?.sort((a, b) => a - b);

  const payload = {
    first_name: values?.first_name,
    last_name: values?.last_name,
    email: values?.email,
    phone_number: values?.phone_number,
    contract: values?.contract,
    contract_period: values?.contract_period
      ? values?.contract_period.toString()
      : '',
    contractType: Number(values?.contractType),
    downpayment: values?.userDeposit || null,
    region: values?.region,
    referralId: values?.referralId,
    vehicle: {
      id: values.vehicle?.value,
      title: values.vehicle?.text,
      instastart: values.vehicle?.instastart || null,
      fee: values.vehicle?.fee,
    },
    comments: values?.comments,
    consents: {
      tos: values?.tos,
      contact: null,
      newsletter: values?.newsletter || false,
      consent_contract: values?.consent_contract || false,
    },
    settings: {
      email_offer: values?.email_offer,
    },
    previous_booking_id: null,
    lang: values?.lang,
    origin: values.origin,
    company: values?.company,
    prepaid_months: prepaidMonths || [],
    marketingCampaignId: values?.applyMarketingCampaign
      ? values?.marketingCampaignId || null
      : null,
    applyMarketingCampaign: values?.applyMarketingCampaign,
    insertProducts: values?.products?.map((item, index) => {
      return {
        ...item,
        order: index,
        discount: item?.discount ? Number(item?.discount) : 0,
        finalPrice: item?.finalPrice?.number
          ? `${item?.finalPrice?.number}`
          : null,
        price: item?.price?.number ? `${item?.price?.number}` : null,
        vat: Number(item?.vat) ? Number(item?.vat) / 100 : Number(item?.vat),
        quantity: item?.quantity ? Number(item?.quantity) : 0,
        customFields: {
          ...item?.customFields,
          months: item?.customFields?.months
            ? item?.customFields?.months?.map((month) => {
                return month.value;
              })
            : undefined,
          extraMonths: item?.customFields?.extraMonths
            ? item?.customFields?.extraMonths?.map((month) => {
                return month.value;
              })
            : undefined,
        },
      };
    }),
    ticketDetails: {
      labels: values?.ticketDetails?.labels?.map((label) => label.value) || [],
    },
  };

  return payload;
};

export const isGuruLeasingUser = (mail) =>
  mail?.endsWith(GURU_LEASING_MAIL_EXTENSION);

export const getDefaultValues = (booking, loggedInUser) => ({
  first_name: booking?.user?.first_name,
  last_name: booking?.user?.last_name,
  email: booking?.user?.email,
  phone_number: booking?.user?.phone_number,
  region: booking?.region,
  contract: booking?.contract_details?.contract,
  lang: booking?.lang,
  contract_period: booking?.contract_details?.contract_period, // TODO: set the right property
  contractType: booking?.contract_details?.contractType,
  applyMarketingCampaign: true,
  tos: true,
  email_offer: true,
  company: isGuruLeasingUser(loggedInUser?.email) ? 'guruleasing' : '',
});

export const STAGE_CUSTOMER_PAID = 5;

export const STAGE_BUY_THE_CAR = 6;

export const hasBookingCustomerTypes = (booking, pendingStage) => {
  const pendingStageNumber = Number(pendingStage);
  const stageIndex = BOOKINGS_STAGES_ORDER.indexOf(pendingStageNumber);

  // Stages before "Docs Received" (index 8) can always be changed
  if (stageIndex < 8) return true;

  // From stage 8+ onwards: can only change if customer types exist
  return booking?.customerTypes?.length > 0;
};

export const hasBookingCarId = (booking, vehicle, pendingStage) => {
  const pendingStageNumber = Number(pendingStage);

  if (pendingStageNumber !== STAGE_BUY_THE_CAR) return true;

  const internal =
    vehicle?.internalId?.toString?.().trim?.() ||
    booking?.vehicle?.vehicle_id?.toString?.().trim?.();
  const fleetInternalId =
    vehicle?.id || booking?.vehicleDetails?.vehicleInternalId;

  return Boolean(internal) || Boolean(fleetInternalId);
};

export const hasBookingPromisedDeliveryDates = (booking, pendingStage) => {
  if (Number(pendingStage) !== STAGE_BUY_THE_CAR) return true;

  // In order to move to "Buy the Car" stage, both promised delivery date and promised delivery date until must be set
  return booking?.promisedDeliveryDate && booking?.promisedDeliveryDateUntil;
};

export const getBookingsSearchPayload = (searchTerm = '') => {
  if (!searchTerm || !searchTerm.trim()) {
    return {
      type: FILTER_RULE_ENUMS.EmptyRuleType,
    };
  }

  const trimmedSearchTerm = searchTerm.trim();

  const fieldsToSearch = ['id'];

  const searchRule = {
    type: FILTER_RULE_ENUMS.OrRuleType,
    value: fieldsToSearch.map((field) => ({
      type: FILTER_RULE_ENUMS.CompareStringRuleType,
      operator: FILTER_OPERATOR_ENUMS.between,
      field,
      value: trimmedSearchTerm,
    })),
  };

  return {
    type: FILTER_RULE_ENUMS.AndRuleType,
    field: null,
    operator: null,
    value: [searchRule],
  };
};
